var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Section',{attrs:{"main":"答疑留言","bg":"Message Board"}}),_c('div',{attrs:{"id":"gitalk-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }